module.exports = __webpack_public_path__ + "img/206.12d60b1c.jpg";